function getAlterPopupUsageOptionFields() {
  const settings =
    typeof emailSubscriptionPopupAlterSettingJsons !== "undefined"
      ? emailSubscriptionPopupAlterSettingJsons
      : null;
  if (!settings) return [];

  const fieldId = settings.usage_option_id;
  if (fieldId == null || String(fieldId).trim() === "") return [];

  const popupEl = document.getElementById("email-subscription-popup-alter");
  if (!popupEl) return [];

  const checked = popupEl.querySelectorAll(
    ".email-subscription-popup__usage-option-checkbox:checked"
  );
  const values = Array.from(checked)
    .map((el) => el.value)
    .filter((v) => v !== undefined && String(v).trim() !== "");

  if (values.length === 0) return [];

  let overwrite = false;
  if (
    settings.usage_option_overwrite != null &&
    settings.usage_option_overwrite !== ""
  ) {
    try {
      overwrite =
        typeof settings.usage_option_overwrite === "string"
          ? JSON.parse(settings.usage_option_overwrite)
          : settings.usage_option_overwrite;
    } catch {
      overwrite = false;
    }
  }

  const numericValues = values.map((v) => Number(v));
  return [{ id: fieldId, type: "multiple", value: numericValues, overwrite }];
}

document.addEventListener("alpine:init", () => {
  const { apiUrl, acceptedLanguage, apiKey, xAppid } = theme.emailSubscription;

  const popup = document.getElementById("email-subscription-popup-alter");
  if (!popup) return;

  const {
    customerTags,
    customerEmail,
    popupDelayDays,
    popupDelaySeconds,
    popupSubscribed,
    autoShowPopup,
    enableSms,
    enableRegistration,
  } = popup.dataset;

  Alpine.data("emailSubscriptionAlterPopup", () => ({
    showTriggerLogo: false,
    showPopup: false,
    showStep: "subscription",
    email: "",
    phoneCode: "+61",
    phoneNumber: "",
    disclaimerChecked: true,
    smsDisclaimerChecked: true,
    errMsg: "",
    loading: false,
    popupDelayDate: null,
    isLogin: false,
    isSubscribed: false,
    isSmsSubscribed: false,
    isMember: false,
    enableSms: true,
    enableRegistration: true,
    subscriptionBtnText: "",
    shouldPageActive: {
      subscription: true,
      sms: true,
      "thank-you": true,
      "thank-you-member": true,
      "thank-you-sms": true,
    },

    toggleTriggerLogo() {
      this.showTriggerLogo = !this.showTriggerLogo;
    },
    togglePopup() {
      this.showPopup = !this.showPopup;
      if (!this.showPopup) {
        const targetDay = new Date();
        targetDay.setHours(0);
        targetDay.setMinutes(0);
        targetDay.setSeconds(0);
        targetDay.setMilliseconds(0);

        const delayDate = new Date().getDate() + this.popupDelayDate;
        targetDay.setDate(delayDate);
        localStorage.setItem(
          `${window.location.hostname}_email_subscription_popup_alter_delay_date`,
          targetDay
        );

        this.resetActivePage();
        this.goNextStep("subscription");

        this.email = "";
        this.disclaimerChecked = false;
        this.errMsg = "";

        const thankYouClosePopupEl = document.getElementById("thank_you_close_popup");
        if (thankYouClosePopupEl) {
          clearTimeout(this._thankYouCloseTimeout);
        }
      }
    },
    resetActivePage() {
      if (this.isLogin) {
        this.shouldPageActive = {
          subscription: !this.isSubscribed,
          sms: !this.isSmsSubscribed && this.enableSms,
          "thank-you": !this.isMember && this.enableRegistration,
          "thank-you-member": true,
          "thank-you-sms": true,
        };
        return;
      }

      this.shouldPageActive = {
        subscription: true,
        sms: this.enableSms,
        "thank-you": this.enableRegistration,
        "thank-you-member": true,
        "thank-you-sms": true,
      };
    },
    setStep(step) {
      this.showStep = step;
    },
    getActiveStep(step) {
      const steps = Object.keys(this.shouldPageActive);
      let index = steps.indexOf(step);

      while (index < steps.length) {
        if (this.shouldPageActive[steps[index]]) {
          return steps[index];
        }
        index++;
      }

      return null;
    },
    goNextStep(expectedNextStep) {
      const nextStep = this.getActiveStep(expectedNextStep);
      this.setStep(nextStep);

      const thankYouClosePopupEl = document.getElementById("thank_you_close_popup");
      if (thankYouClosePopupEl && thankYouClosePopupEl.value === "true") {
        const thankYouSteps = ["thank-you", "thank-you-member", "thank-you-sms"];
        if (thankYouSteps.includes(nextStep)) {
          const delay = parseInt(document.getElementById("thank_you_close_popup_delay")?.value || "3000", 10);
          this._thankYouCloseTimeout = setTimeout(() => {
            this.togglePopup();
          }, delay);
        }
      }
    },
    async submitEmailForm() {
      this.errMsg = "";

      const isEmailValid = validateEmail(this.email);
      if (!this.disclaimerChecked) {
        this.errMsg = "Please agree to the Privacy Policy and Terms of Service.";
        return;
      }
      if (this.email === "") {
        this.errMsg = "Please enter your email address.";
        return;
      }
      if (!isEmailValid) {
        this.errMsg = "Please enter a valid email address (Example: name@domain.com)";
        return;
      }

      const { data } = await this.fetchCustomerInfo(this.email);

      this.shouldPageActive = {
        ...this.shouldPageActive,
        sms: !data.acceptsMarketingSms && this.enableSms,
        "thank-you": !data.registerUser && this.enableRegistration,
      };

      const fieldsArray = [
        ...createFieldsArray(emailSubscriptionPopupAlterSettingJsons),
        ...getAlterPopupUsageOptionFields(),
      ];
      const contactListId = getContactListId(emailSubscriptionPopupAlterSettingJsons);

      const subscribeInfoCookie = window.getCookieForEmarsys('subscribe_info');
      let eventTracking = null;

      if (subscribeInfoCookie) {
        try {
          const decodedCookie = decodeURIComponent(subscribeInfoCookie);
          eventTracking = JSON.parse(decodedCookie);
          delete eventTracking.ts;
        } catch (error) {
          console.warn('Failed to parse subscribe_info cookie:', error);
        }
      }

      const apiBody = {
        email: this.email,
        contactListId,
        smsContactListId: emailSubscriptionPopupAlterSettingJsons.contact_list_id_sms,
        fields: fieldsArray,
        ...(eventTracking && { eventTracking }),
      };

      try {
        this.loading = true;
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            apiKey: apiKey,
            traceId: traceId,
            "X-appid": xAppid,
            "Accepted-Language": acceptedLanguage,
          },
          body: JSON.stringify(apiBody),
        });

        const data = await response.json();

        if (data.message === "Success") {
          this.goNextStep("sms");

          if (this.email === customerEmail) {
            this.shouldPageActive.subscription = false;
            this.isSubscribed = true;
          }
        } else {
          this.errMsg = "Oops... Something went wrong, please refresh and try again.";
        }
      } catch (error) {
        this.errMsg = "Oops... Something went wrong, please refresh and try again.";
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async submitSmsForm() {
      this.errMsg = "";

      const phone = `${this.phoneCode}${this.phoneNumber}`;

      const isPhoneNumberValid = () => {
        const phoneNumberRegex = /^(?=.{9,15}$)\+\d(-?\d)*$/;
        const containOnlyOneOrNoHyphen = phone.split("-").length - 1 <= 1;
        return phoneNumberRegex.test(phone) && containOnlyOneOrNoHyphen;
      };

      if (!this.smsDisclaimerChecked) {
        this.errMsg = "Please tick agreement box to proceed.";
        return;
      }
      if (this.phoneNumber === "") {
        this.errMsg = "Please enter your phone number.";
        return;
      }
      if (!isPhoneNumberValid(phone)) {
        this.errMsg = "Please enter a valid phone number";
        return;
      }

      const {
        s_id_sms,
        s_value_sms,
        s_overwrite_sms,
        t_id_sms,
        t_value_sms,
        t_overwrite_sms,
        m_id_sms,
        m_value_sms,
        m_overwrite_sms,
        m_2_id_sms,
        m_2_value_sms,
        m_2_overwrite_sms,
        contact_list_id_sms,
      } = emailSubscriptionPopupAlterSettingJsons;

      let fieldsArray = [
        ...createFieldsArray(emailSubscriptionPopupAlterSettingJsons),
        ...getAlterPopupUsageOptionFields(),
      ];
      const contactListId = getContactListId(emailSubscriptionPopupAlterSettingJsons);
      fieldsArray = [
        ...fieldsArray,
        ...(s_id_sms ? [{ id: s_id_sms, type: "single", value: Number(s_value_sms), overwrite: JSON.parse(s_overwrite_sms) }] : []),
        ...(t_id_sms ? [{ id: t_id_sms, type: "text", value: Number(t_value_sms), overwrite: JSON.parse(t_overwrite_sms) }] : []),
        ...(m_id_sms ? [{ id: m_id_sms, type: "multiple", value: m_value_sms.split(",").map((item) => Number(item)), overwrite: JSON.parse(m_overwrite_sms) }] : []),
        ...(m_2_id_sms ? [{ id: m_2_id_sms, type: "multiple", value: m_2_value_sms.split(",").map((item) => Number(item)), overwrite: JSON.parse(m_2_overwrite_sms) }] : []),
      ];

      const subscribeInfoCookie = window.getCookieForEmarsys('subscribe_info');
      let eventTracking = null;

      if (subscribeInfoCookie) {
        try {
          const decodedCookie = decodeURIComponent(subscribeInfoCookie);
          eventTracking = JSON.parse(decodedCookie);
          delete eventTracking.ts;
        } catch (error) {
          console.warn('Failed to parse subscribe_info cookie:', error);
        }
      }

      const apiBody = {
        email: this.email === "" ? customerEmail : this.email,
        phone,
        contactListId,
        smsContactListId: contact_list_id_sms,
        fields: fieldsArray,
        ...(eventTracking && { eventTracking }),
      };

      try {
        this.loading = true;
        const checkPhoneRegistered = await this.fetchCustomerInfo(
          this.email === "" ? customerEmail : this.email,
          encodeURIComponent(phone)
        );

        if (checkPhoneRegistered.data.registerPhone) {
          this.errMsg = "This phone number is already registered.";
          return;
        }

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            apiKey: apiKey,
            traceId: traceId,
            "X-appid": xAppid,
            "Accepted-Language": acceptedLanguage,
          },
          body: JSON.stringify(apiBody),
        });

        const data = await response.json();

        if (data.message === "Success") {
          const shouldSmsPageActive =
            this.email === "" ? false : this.email !== customerEmail;

          this.shouldPageActive = {
            ...this.shouldPageActive,
            sms: shouldSmsPageActive,
            "thank-you": !this.isMember && this.enableRegistration,
            "thank-you-member": false,
          };
          this.isSmsSubscribed = !shouldSmsPageActive;

          this.goNextStep("thank-you");
        } else {
          this.errMsg = "Oops... Something went wrong, please refresh and try again.";
        }
      } catch (error) {
        this.errMsg = "Oops... Something went wrong, please refresh and try again.";
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async fetchCustomerInfo(email, phone) {
      try {
        this.loading = true;
        const phoneQuery = phone ? `&phone=${phone}` : "";
        const response = await fetch(
          `https://api-a.ecoflow.com/website/subscribe/searchSubInfo?email=${email}${phoneQuery}`,
          {
            method: "GET",
            headers: {
              "X-appid": xAppid,
            },
          }
        );
        const data = await response.json();
        return data;
      } catch (error) {
        throw new Error(error);
      } finally {
        this.loading = false;
      }
    },
    init() {
      this.isLogin = customerEmail ? true : false;
      this.isMember = customerEmail ? true : false;
      this.enableSms = enableSms ? JSON.parse(enableSms) : true;
      this.enableRegistration = enableRegistration ? JSON.parse(enableRegistration) : true;
      this.subscriptionBtnText = popup.dataset.subscriptionBtnText || "Subscribe";

      this.shouldPageActive = {
        ...this.shouldPageActive,
        sms: this.enableSms,
        "thank-you": this.enableRegistration,
      };

      if (customerEmail) {
        const fetchCustomerInformation = async () => {
          try {
            const data = await this.fetchCustomerInfo(customerEmail);

            if (data.message === "Success") {
              const { acceptsMarketing, acceptsMarketingSms, registerUser } = data.data;

              this.isSubscribed = acceptsMarketing;
              this.isSmsSubscribed = acceptsMarketingSms;
              this.shouldPageActive = {
                ...this.shouldPageActive,
                subscription: !acceptsMarketing,
                sms: !acceptsMarketingSms && this.enableSms,
                "thank-you": !registerUser && this.enableRegistration,
              };

              if (
                acceptsMarketing ||
                (acceptsMarketing && acceptsMarketingSms && registerUser) ||
                (acceptsMarketing && !this.enableSms && !this.enableRegistration)
              ) {
                document.getElementById("email-subscription-popup-alter").remove();
                return;
              } else {
                this.showTriggerLogo = true;
              }

              this.goNextStep("subscription");
            }
          } catch (error) {
            console.log(error);
            document.getElementById("email-subscription-popup-alter").remove();
          }
        };

        fetchCustomerInformation();
      } else {
        this.showTriggerLogo = true;
      }

      this.popupDelayDate = Number(popupDelayDays);

      const now = new Date();
      const delayDate = localStorage.getItem(
        `${window.location.hostname}_email_subscription_popup_alter_delay_date`
      );

      const isDelayDateValid = now.getTime() < new Date(delayDate).getTime();
      const parsedAutoShowPopup = autoShowPopup ? JSON.parse(autoShowPopup) : false;

      if (!this.isSubscribed && !isDelayDateValid && parsedAutoShowPopup) {
        setTimeout(() => {
          this.showPopup = true;
        }, Number(popupDelaySeconds) * 1000);
      }
    },
    phoneCodeList: [
      "+1", "+7", "+20", "+27", "+30", "+31", "+32", "+33", "+34", "+36",
      "+39", "+40", "+41", "+43", "+44", "+45", "+46", "+47", "+48", "+49",
      "+51", "+52", "+53", "+54", "+55", "+56", "+57", "+58", "+60", "+61",
      "+62", "+63", "+64", "+65", "+66", "+81", "+82", "+84", "+86", "+90",
      "+91", "+92", "+94", "+95", "+98", "+211", "+212", "+213", "+216",
      "+218", "+220", "+221", "+222", "+223", "+224", "+225", "+226", "+227",
      "+228", "+229", "+230", "+231", "+232", "+233", "+234", "+235", "+236",
      "+237", "+238", "+239", "+240", "+241", "+242", "+243", "+244", "+245",
      "+246", "+248", "+249", "+250", "+251", "+252", "+253", "+254", "+255",
      "+256", "+257", "+258", "+260", "+261", "+262", "+263", "+264", "+265",
      "+266", "+267", "+268", "+269", "+290", "+291", "+297", "+298", "+299",
      "+350", "+351", "+352", "+353", "+354", "+355", "+356", "+357", "+358",
      "+359", "+370", "+371", "+372", "+373", "+374", "+375", "+376", "+377",
      "+378", "+379", "+380", "+381", "+382", "+383", "+385", "+386", "+387",
      "+389", "+420", "+421", "+423", "+500", "+501", "+502", "+503", "+504",
      "+505", "+506", "+507", "+508", "+509", "+590", "+591", "+592", "+593",
      "+594", "+595", "+596", "+597", "+598", "+599", "+670", "+672", "+673",
      "+674", "+675", "+676", "+677", "+678", "+679", "+680", "+681", "+682",
      "+683", "+685", "+686", "+687", "+688", "+689", "+690", "+691", "+692",
      "+850", "+852", "+853", "+855", "+856", "+870", "+880", "+886", "+960",
      "+961", "+962", "+963", "+964", "+965", "+966", "+967", "+968", "+970",
      "+971", "+972", "+973", "+974", "+975", "+976", "+977", "+992", "+993",
      "+994", "+995", "+996", "+998", "+0055", "+1721", "+1-242", "+1-246",
      "+1-264", "+1-268", "+1-284", "+1-340", "+1-345", "+1-441", "+1-473",
      "+1-649", "+1-664", "+1-670", "+1-671", "+1-684", "+1-758", "+1-767",
      "+1-784", "+1-868", "+1-869", "+1-876", "+358-18", "+44-1481",
      "+44-1534", "+44-1624",
    ],
  }));
});
